import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { StorageService } from 'src/app/services/storage.service';
import { StreamingService } from 'src/app/services/streaming.service';
import { ConfirmModalComponent } from '../../modals/confirm-modal/confirm-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { IOpenedSchedule } from 'src/app/models/transactions';

@Component({
  selector: 'app-card-to-bid',
  templateUrl: './card-to-bid.component.html',
  styleUrls: ['./card-to-bid.component.scss'],
})
export class CardToBidComponent implements OnInit {
  constructor(
    private storage: StorageService,
    private streaming: StreamingService,
    private dialog: MatDialog,
  ) {}

  @Input() is_live: 'LIVE' | 'DETAILS' = 'LIVE';
  @Input() bid_type: 'VIRTUAL' | 'AOVIVO' | 'PRELANCE' | 'SHOPPING' | '' = '';
  @Input() animal_obj?: any = {};

  @Output() eventCardToBidSocket = new EventEmitter<any>();

  loading = 0;
  is_login = false;

  user = this.storage.myself;

  timer: number = 3 * 60 * 1000; // 3 minutos
  timerStartCheck: any = 20 * 60 * 1000; // 20 minutos
  timerToEnd: any = 0;
  time = { days: 0, hour: 0, min: 0, seg: 0 };

  opened_schedule: any = [] as IOpenedSchedule[];

  bid_status: 'FINISH' | 'REAL_TIME' | 'OPEN' | 'CLOSED' = 'OPEN';
  isStatus: 'ACEITO' | 'SUPERADO' | 'RECUSADO' |  'AGUARDANDO'  | '' = '';

  next_bid = 0;
  attual_bid = 0;

  ngOnInit(): void {
    this.setStart(false);

    this.streaming.watchSocket().subscribe({
      next: () => {
        this.setStart(true);
      },
    });
  }

  setStart(openPopup: boolean) {
    if (this.storage.token && this.storage.token !== '') {
      this.is_login = true;
    }

    if(this.animal_obj?.id) this.openedAnimal(openPopup)
    else this.openedScheldule(openPopup)
  }

  openedScheldule(openPopup: boolean) {

    this.loading += 1;

    if(this.streaming.auctions) this.opened_schedule = Object.assign({}, this.streaming.auctions.length > 0 ? this.streaming.auctions[0] : {})

    this.isStatus = ''

    if(!this.opened_schedule.transaction){
      this.loading -= 1;
      return;
    }

    const animal = this.opened_schedule?.transaction?.animal;
    const auction_bid = this.opened_schedule?.transaction?.auction_bid;
    const last_auction_bid = this.opened_schedule?.transaction?.last_auction_bid;
    const waiting_bids = this.opened_schedule?.transaction?.waiting_bids;

    if(this.animal_obj?.user === this.user.id){     // #3
      this.isStatus = 'ACEITO'
    }

    if(last_auction_bid?.user === this.user.id){
      this.isStatus = last_auction_bid?.status || '';
    }

    if (waiting_bids && waiting_bids.length > 0) {
      const lance = waiting_bids.filter((el: any) => this.user.id === el.user)

      if(lance.length > 0){
        this.isStatus = lance[0].status
      }
      else if(this.animal_obj.bids){
        const lance = this.animal_obj.bids.filter((el: any) => this.user.id === el.user)
        if(lance.length > 0){
          this.isStatus = lance[0].status
        }
        else{
          this.isStatus = 'AGUARDANDO'
        }
      }
    }

    // auction_bid =        ACEITO SEMPRE
    // last_auction_bid =   SUPERADO SEMPRE
    // waiting_bids =       AGUARDANDO SEMPRE

    if(openPopup && this.isStatus === 'RECUSADO') this.OpenMessageOutbid();

    const increment = this.opened_schedule.increment || 20;

    console.log('AQUI', auction_bid, animal);
    console.log('--->', auction_bid, animal);

    if(auction_bid){
      console.log('-> ENTROU AQUI PRIMEIRP');
      const value_bid = auction_bid.value || animal.bid;
      this.next_bid = (value_bid || 500) + Number(increment);
      this.attual_bid = auction_bid.value || animal?.bid;
    }
    else if(animal){
      console.log('-> ENTROU AQUI 2');
      const value_bid = animal.bid;
      this.next_bid = (value_bid || 500) + Number(increment);
      this.attual_bid = animal?.bid;;
    }

    this.loading -= 1;
  }

  OpenMessageOutbid(){
    this.dialog.open(ConfirmModalComponent, {
      width: '90%',
      maxWidth: '500px',
      disableClose: true,
      data: {
        title: '',
        message: 'Problemas com o lance, favor entrar em contato com a wv pelo telefone (18)3551-9696.',
        confirm: 'Fechar',
        cancell: ''
      },
    });
  }

  openedAnimal(openPopup: boolean){

    this.loading += 1;

    this.opened_schedule = Object.assign({}, this.animal_obj.schedule_event)

    this.isStatus = ''

    const animal = this.opened_schedule?.transaction?.animal || this.animal_obj;
    const auction_bid = this.opened_schedule?.transaction?.auction_bid;
    const last_auction_bid = this.opened_schedule?.transaction?.last_auction_bid;
    const waiting_bids = this.opened_schedule?.transaction?.waiting_bids || this.animal_obj.bids;

    if(this.animal_obj?.user === this.user.id){     // #3
      this.isStatus = 'ACEITO'
    }

    if(last_auction_bid?.user === this.user.id){
      this.isStatus = last_auction_bid?.status || '';
    }

    if (waiting_bids && waiting_bids.length > 0) {
      const lance = waiting_bids.filter((el: any) => this.user.id === el.user)

      if(lance.length > 0){
        this.isStatus = lance[0].status
      }
      else if(this.animal_obj.bids){
        const lance = this.animal_obj.bids.filter((el: any) => this.user.id === el.user)
        if(lance.length > 0){
          this.isStatus = lance[0].status
        }
        else{
          this.isStatus = 'AGUARDANDO'
        }
      }
    }

    if(openPopup && this.isStatus === 'RECUSADO') this.OpenMessageOutbid();

    const increment = this.animal_obj.attual_increment || 20;


    if(auction_bid){
      const value_bid = auction_bid?.value || animal?.attual_bid || animal?.bid;
      this.next_bid = (value_bid || 500) + Number(increment);
      this.attual_bid = auction_bid.value || animal?.bid;
    }
    else if(animal){
      const value_bid = animal?.attual_bid || animal.bid;
      this.next_bid = (value_bid || 500) + Number(increment);
      this.attual_bid = animal?.attual_bid || animal?.bid;
    }

    // this.next_bid = (value_bid || 500) + Number(increment);
    // this.attual_bid = this.animal_obj?.attual_bid;

    if(!this.animal_obj.bids || this.animal_obj.bids.length <= 0){
      this.loading -= 1;
      return;
    }

    const array_bids = this.animal_obj.bids.filter((el: any) => el.type === 'PRE LANCE')

    if (array_bids.length > 0) {

      const lance = this.animal_obj.bids.filter((el: any) => this.user.id === el.user)
      if(lance.length > 0){
        this.isStatus = lance[0]?.status === 'ACEITO' ? 'ACEITO' : lance[0].status;
      }

      if(array_bids[0].user !== this.user.id && array_bids[0].status === 'ACEITO'){
        this.isStatus = 'SUPERADO'
      }
    }


    this.loading -= 1;
  }

  eventSocket(event: any) {
    this.eventCardToBidSocket.emit(true);
  }
}
